import { render } from "./OnboardSuccess.vue?vue&type=template&id=056b55d2&scoped=true&ts=true"
import script from "./OnboardSuccess.vue?vue&type=script&lang=ts"
export * from "./OnboardSuccess.vue?vue&type=script&lang=ts"

import "./OnboardSuccess.vue?vue&type=style&index=0&id=056b55d2&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056b55d2"]])

export default __exports__